import { Component, OnInit } from '@angular/core';
import { IconSize } from '../../../enums/icon.enum';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../../atoms/icon/icon.component';
import { Router, RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectIsLoggedIn } from '../../../../core/state/auth/auth.selectors';
import { TranslateModule } from '@ngx-translate/core';
import { AnalyticsConsentService } from '../../../../core/services/analytics-consent.serivice';
import { GoogleAnalyticsService } from '../../../../core/services/google-analytics.service';

@Component({
  selector: 'app-cookie-banner',
  imports: [CommonModule, IconComponent, RouterModule, TranslateModule],
  templateUrl: './cookie-banner.component.html',
  styleUrl: './cookie-banner.component.scss'
})
export class CookieBannerComponent implements OnInit {
  public IconSize = IconSize;
  public isVisible = !localStorage.getItem('cookieConsent');
  public privacyLink: string[] = ['/privacy-policy'];

  constructor(
    private router: Router,
    private store: Store,
    private consent: AnalyticsConsentService,
    private ga: GoogleAnalyticsService
  ) {}

  ngOnInit(): void {
    this.store.select(selectIsLoggedIn).subscribe(isLoggedIn => {
      this.privacyLink = isLoggedIn ? ['/privacy'] : ['/privacy-policy'];
    });
  }

  acceptAll(): void {
    this.consent.setConsent('accepted');
    this.isVisible = false;

    // load GA only now
    this.ga.init();

    // track current page immediately
    this.ga.trackPage(this.router.url);
  }

  decline(): void {
    localStorage.setItem('cookieConsent', 'declined');
    this.isVisible = false;
  }
}